import axios from 'axios'
import store from '../store/index'
import { BASEURL, TESTURL } from './config'
import { getpostKey } from '@/utils/utils'

const cache = {}

function httpGet(url, cachebol = false, headers = null) {
  let options = !headers ? {} : {
    headers
  }
  if (cachebol && cache[url]) {
    console.log('拿了缓存')
    return Promise.resolve(cache[url])
  }
  return axios.get(url, options).then(res => {
    let code = res.data.code;
    if(code && code !== 200 && code !== 201){
      return Promise.reject(res.data.warning || res.data.message)
    }
    if (cachebol) {
      cache[url] = res
    }
    return res
  })
}

function httpPost(url, data = {}, cachebol=false, headers = null) {
  let options = !headers ? {} : {
    headers
  }
  // 用getpostKey是因为data如果是formdata就序列化拿不到值
  const key = getpostKey(url, data)
  if (cachebol && cache[key]) {
    console.log('拿了缓存')
    return Promise.resolve(cache[key])
  }
  return axios.post(url, data, options).then(res => {
    let code = res.data.code;
    if(code && code !== 200 && code !== 201){
      return Promise.reject(res.data.warning || res.data.message)
    }
    if (cachebol) {
      cache[key] = res
    }
    return res;
  });
}

function httpDelete(url,isData=true,data={}) {
  let paramsobj = {
    ...isData&&{data},
    ...!isData&&{params:data}
  }
  return axios.delete(url, paramsobj).then(res => {
    let code = res.data.code;
    if(code && code !== 200 && code !== 201){
      return Promise.reject(res.data.warning || res.data.message)
    }
    return res;
  });
}

function httpPatch(url,data={}) {
  return axios.patch(url,data).then(res=>{
    let code = res.data.code;
    if(code && code !== 200 && code !== 201){
      return Promise.reject(res.data.warning || res.data.message)
    }
    return res;
  })
}

axios.interceptors.request.use(
  config => {
    return config
   },
   error => {
    return Promise.reject(error)
   }
)
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log("err:::",error)
    let message = ''
    if(/^4/.test(error.response.status)){
      message = error.response.data.message
    } else {
      message = "服务器异常"
    }
    return Promise.reject({success:false,message})
  }
)

export function getOwnList(data){
  return httpPost(
    `${BASEURL}/collect_pic/own_project_list`,
    data)
}

export function getjoinList(data){
  return httpPost(
    `${BASEURL}/collect_pic/participate_project_list`,
    data
  )
}

export function getDefault(){
  return httpGet(`${BASEURL}/internal_alipay/default_parameter`, true)
}

export function getJoindetail(data){
  return httpPost(
    `${BASEURL}/collect_pic/participate_order_information`,
    data
  )
}

export function getOwnerDetail(data){
  return httpPost(
    `${BASEURL}/collect_pic/owner_order_information`,
    data
  )
}

export function specClassify(){
  return httpGet(
    `${BASEURL}/internal_alipay/specs_category`,
    true
  )
}

export function showSpecs({id, pageIndex}){
  return httpGet(
    `${BASEURL}/internal_alipay/query_category_specs?id=${id}&page=${pageIndex}`,
    true
  )
}

export function getKeyword({pageIndex, key}){
  return httpGet(
    `${BASEURL}/internal_alipay/query_keyword?page=${pageIndex}&keyword=${encodeURI(key)}`,
    true
  )
}

export function getSpecDetail(id){
  return httpGet(
    `${BASEURL}/internal_alipay/query_specs_id?spec_id=${id}`,
    true
  )
}

export function createPro(data){
  return httpPost(
    `${BASEURL}/collect_pic/create_project`,
    data
  )
}

export function sendEmail(data){
  return httpPost(
    `${BASEURL}/internal_alipay/alipay_send_mail`,
    data
  )
}

export function ownerEmail(data){
  return httpPost(
    `${BASEURL}/collect_pic/collect_send_mail`,
    data
  )
}

export function updatetime(data){
  return httpPost(
    `${BASEURL}/collect_pic/update_time`,
    data,
  )
}

export function refundpic(data){
  return httpPost(
    `${BASEURL}/collect_pic/refund_pic`,
    data
  )
}

export function getClothes(){
  return httpGet(
    `${BASEURL}/internal_alipay/formal_clothes`,
    true
  )
}

export function makephoto_v2 (data) {
  const url ="internal_alipay/cut_photo_v2"
  return httpPost(
    `${BASEURL}/${url}`,
    data
  )
}

export function getWechatSdk (url) {
  return httpGet(
    `${BASEURL}/union_applet/union_wechat_signature?url=${encodeURIComponent(url)}`
  )
}

export function uploadPic (data) {
  return httpPost(
    `${BASEURL}/collect_pic/upload_pic`,
    data
  )
}

export function addteampeople (data) {
  return httpPost(
    `${BASEURL}/collect_pic/share_inner_users`,
    data
  )
}

export function getCollectPay (orderid) {
  return httpGet(
    `${BASEURL}/collect_pic/wechat_pay?order_id=${orderid}`
  )
}

export function createCollectOrder (data) {
  return httpPost(
    `${BASEURL}/collect_pic/create_order`,
    data
  )
}

export function savephone({orderid, type}){
  let url = `${BASEURL}/internal_alipay/save_phone?order_id=${orderid}`
  url = type ? url + `&type=${type}` : url
  return httpGet(
    url,
    true
  )
}

export function getLogin(data){
  return httpPost(
    `${BASEURL}/collect_pic/wechat_get_openid`,
    data
  )
}

export function getQrcode(data){
  return httpPost(
    `${BASEURL}/collect_pic/wechat_qrcode`,
    data,
    true
  )
}